import React, { FunctionComponent } from 'react';

import styles from './TwitterTweetCardTopicIcons.module.scss';
import RelatedItemsPop from '../RelatedItemsPop';
import {
  getPostsRelatedItemsForTopic,
  getTweetsRelatedItemsForTopic,
} from 'topics/Requests';
import { BookmarkIcon, SmallHashtagIcon } from 'app/assets/images/icons';
import { Grid } from '@material-ui/core';
import { _t } from 'app/utils/i18n';

interface Props {
  hashtags_count?: number;
  topic_id: number;
  item_id: number;
  match_percentage: number;
  keywords_count?: number;
  onItemClickAction?: (word: any, wordType: string) => void;
}

const TwitterTweetCardTopicIcons: FunctionComponent<Props> = ({
  item_id,
  topic_id,
  hashtags_count,
  match_percentage,
  onItemClickAction,
  keywords_count,
}) => {
  return (
    <div className={styles.TwitterTweetCardTopicIcons}>
      <div className={styles.bookmark}>
        {hashtags_count && hashtags_count > 0 ? (
          <RelatedItemsPop
            topic_id={topic_id}
            item_id={item_id}
            slug={getTweetsRelatedItemsForTopic}
            icon={<SmallHashtagIcon />}
            title={_t('topics:related_hashtags')}
            onItemClickAction={(word: any) =>
              onItemClickAction?.(word, 'hashtag_ids')
            }
          />
        ) : null}
        {keywords_count && keywords_count > 0 ? (
          <RelatedItemsPop
            topic_id={topic_id}
            item_id={item_id}
            slug={getPostsRelatedItemsForTopic}
            title={_t('topics:related_keyword')}
            onItemClickAction={(word: any) =>
              onItemClickAction?.(word, 'keywords_ids')
            }
          />
        ) : null}
        <BookmarkIcon />
      </div>

      {match_percentage > 0 && (
        <Grid item className={styles.percentage}>
          <p>{Math.round(match_percentage * 1000) / 10} %</p>
        </Grid>
      )}
    </div>
  );
};

export default TwitterTweetCardTopicIcons;
